import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { WorkerCare } from '../../../class/worker-care';
import { WorkerCareService } from '../../../service/worker-care/worker-care.service';
import { TranslateService } from '@ngx-translate/core';
import { Message, SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { RadicationSSService } from '../../../service/radicationSS/radicationSS.service';
import { calendarES } from '../../../../../theme/functions/calendarES';
import { sortObj } from '../../../../../theme/functions/sortObj.function';

@Component({
  selector: 'app-new-worker-care',
  templateUrl: './new-worker-care.component.html',
  styleUrls: ['./new-worker-care.component.scss']
})
export class NewWorkerCareComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: WorkerCare;
    @Input() verification: boolean;
    @Input() gestionSac: any;

    messages: Message[] = [];

    public promiseForm: Promise<any>;
    public form: FormGroup;

    public executive_id: AbstractControl;
    public date_received: AbstractControl;
    public company_id: AbstractControl;
    public candidate_id: AbstractControl;
    public candidate_document: AbstractControl;
    public observation_delivery_process: AbstractControl;
    public description_activity: AbstractControl;

    public radication: AbstractControl;
    public department_id: AbstractControl;
    public venue_id: AbstractControl;
    public beneficiaries_registered: AbstractControl;
    public tramite: AbstractControl;
    public date_delivery: AbstractControl;
    public eps_ccf: AbstractControl;
    public observations_facilitator: AbstractControl;
    public report_user_id: AbstractControl;

    public statusOptions: {label: string, value: string, selected: boolean, disabled: boolean}[];

    public es: any;

    public modViewDialog: boolean;

    public optionsSelectionDescriptionActivity: any[];
    public optionsSelectionBeneficiariesRegistered: any[];
    public optionsSelectionTramite: any[];

    public save_exit: boolean;

    constructor(
        fb: FormBuilder,
        public workerCareService: WorkerCareService,
        public translate: TranslateService,
        private notificationsService: NotificationsService,
        public radicationSSService: RadicationSSService) {
        this.modViewDialog = false;

        this.save_exit = false;

        this.es = calendarES();
        

        this.optionsSelectionDescriptionActivity = [];
            this.optionsSelectionDescriptionActivity.push({label: 'Inclusión EPS', value: '116'});
            this.optionsSelectionDescriptionActivity.push({label: 'Traslado EPS', value: '117'});
            this.optionsSelectionDescriptionActivity.push({label: 'Inclusión CCF', value: 'Inclusión CCF'});
            this.optionsSelectionDescriptionActivity.push({label: 'Aclaracion inquietud nomina', value: 'Aclaracion inquietud nomina'});
            this.optionsSelectionDescriptionActivity.push({label: 'Certificacion electrónica', value: 'Certificacion electrónica'});
            this.optionsSelectionDescriptionActivity.push({label: 'Carta de Cesantias', value: 'Carta de Cesantias'});
            this.optionsSelectionDescriptionActivity.push({label: 'Certificado Ingresos y Retenciones', value: 'Certificado Ingresos y Retenciones'});
            this.optionsSelectionDescriptionActivity.push({label: 'Generación desprendible pago electrónico', value: 'Generación desprendible pago electrónico'});
            this.optionsSelectionDescriptionActivity.push({label: 'Tramite Carnet ARL', value: 'Tramite Carnet ARL'});
            this.optionsSelectionDescriptionActivity.push({label: 'Verificación CCF', value: 'Verificación CCF'});
            this.optionsSelectionDescriptionActivity.push({label: 'Verificacion EPS', value: 'Verificacion EPS'});
            this.optionsSelectionDescriptionActivity.push({label: 'Ausentismo', value: '115'});
            this.optionsSelectionDescriptionActivity.push({label: 'Incapacidades', value: '118'});
            this.optionsSelectionDescriptionActivity.push({label: 'Paz y Salvo', value: '13'});
            this.optionsSelectionDescriptionActivity.push({label: 'Documento Adicional', value: 'Documento Adicional'});
            this.optionsSelectionDescriptionActivity.push({label: 'Facturas de servicios', value: 'Facturas de servicios'});
            this.optionsSelectionDescriptionActivity.push({label: 'Afiliación Fonredes', value: '111'});
            this.optionsSelectionDescriptionActivity.push({label: 'Proceso Disciplinario', value: '73'});
            this.optionsSelectionDescriptionActivity.push({label: 'Firma documentos liquidación', value: 'Firma documentos liquidación'});
            this.optionsSelectionDescriptionActivity.push({label: 'Firma clausula u otro si', value: 'Firma clausula u otro si'});
            this.optionsSelectionDescriptionActivity.push({label: 'Solicitud devol aportes Fonredes', value: '112'});
            this.optionsSelectionDescriptionActivity.push({label: 'Solicitud prestamo Fonredes', value: '113'});
            this.optionsSelectionDescriptionActivity.push({label: 'Terminación de contrato', value: 'Terminación de contrato'});
            this.optionsSelectionDescriptionActivity.push({label: 'Convenios Fonredes', value: 'Convenios Fonredes'});
            this.optionsSelectionDescriptionActivity.push({label: 'Modificación de Cuota Fonredes', value: '114'});
            this.optionsSelectionDescriptionActivity.push({label: 'Aclaración de Dudas', value: 'Aclaración de Dudas'});
            this.optionsSelectionDescriptionActivity.push({label: 'Actualización de Datos Sortime', value: 'Actualización de Datos Sortime'});
            this.optionsSelectionDescriptionActivity.push({label: 'Autoliquidación', value: 'Autoliquidación'});
            this.optionsSelectionDescriptionActivity.push({label: 'Autorización de Descuento', value: 'Autorización de Descuento'});
            this.optionsSelectionDescriptionActivity.push({label: 'Código de Compra', value: 'Código de Compra'});
            this.optionsSelectionDescriptionActivity.push({label: 'Validación de Cuenta Bancaria', value: 'Validación de Cuenta Bancaria'});
            this.optionsSelectionDescriptionActivity.push({label: 'Envío Planilla Seguridad Social', value: 'Envío Planilla Seguridad Social'});
            this.optionsSelectionDescriptionActivity.push({label: 'Aceptación de renuncia', value: 'Aceptación de renuncia'});
            this.optionsSelectionDescriptionActivity.push({label: 'Actualización SSFF', value: 'Actualización SSFF'});
            this.optionsSelectionDescriptionActivity.push({label: 'Retiros SSF', value: 'Retiros SSF'});
            this.optionsSelectionDescriptionActivity.push({label: 'Reporte casos Covid', value: 'Reporte casos Covid'});
            this.optionsSelectionDescriptionActivity.push({label: 'Informe a clientes', value: 'Informe a clientes'});
            this.optionsSelectionDescriptionActivity.push({label: 'Capacitación', value: 'Capacitación'});
            this.optionsSelectionDescriptionActivity.push({label: 'Seguimiento de recomendaciónes', value: 'Seguimiento de recomendaciónes'});
            this.optionsSelectionDescriptionActivity.push({label: 'Seguimiento de condiciones de salud', value: 'Seguimiento de condiciones de salud'});
            this.optionsSelectionDescriptionActivity.push({label: 'Investigación de accidente', value: 'Investigación de accidente'});
            this.optionsSelectionDescriptionActivity.push({label: 'Verificación de referencia laboral', value: 'Verificación de referencia laboral'});
            this.optionsSelectionDescriptionActivity.push({label: 'Actividad adicional', value: 'Actividad adicional'});
            this.optionsSelectionDescriptionActivity= sortObj(this.optionsSelectionDescriptionActivity, 'asc');
            
            this.optionsSelectionBeneficiariesRegistered = [];
            this.optionsSelectionBeneficiariesRegistered.push({label: 'N/A', value: 'N/A'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '1', value: '1'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '2', value: '2'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '3', value: '3'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '4', value: '4'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '5', value: '5'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '6', value: '6'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '7', value: '7'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '8', value: '8'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '9', value: '9'});
            this.optionsSelectionBeneficiariesRegistered.push({label: '10', value: '10'});

            this.optionsSelectionTramite = [];
            this.optionsSelectionTramite.push({label: 'Inclusión EPS', value: 'Inclusión EPS'});
            this.optionsSelectionTramite.push({label: 'Traslado EPS', value: 'Traslado EPS'});
            this.optionsSelectionTramite.push({label: 'Inclusión CCF', value: 'Inclusión CCF'});
            this.optionsSelectionTramite.push({label: 'Afiliación Fonredes', value: 'Afiliación Fonredes'});
            this.optionsSelectionTramite.push({label: 'Proceso Disciplinario', value: 'Proceso Disciplinario'});
            this.optionsSelectionTramite.push({label: 'Firma documentos liquidación', value: 'Firma documentos liquidación'});
            this.optionsSelectionTramite.push({label: 'Firma clausula u otro si', value: 'Firma clausula u otro si'});
            this.optionsSelectionTramite.push({label: 'Incapacidades', value: 'Incapacidades'});
            this.optionsSelectionTramite.push({label: 'Solicitud devol aportes Fonredes', value: 'Solicitud devol aportes Fonredes'});
            this.optionsSelectionTramite.push({label: 'Solicitud prestamo Fonredes', value: 'Solicitud prestamo Fonredes'});
            this.optionsSelectionTramite.push({label: 'Terminación de contrato', value: 'Terminación de contrato'});
            this.optionsSelectionTramite.push({label: 'Paz y salvos', value: 'Paz y salvos'});
            this.optionsSelectionTramite.push({label: 'Documento Adicional', value: 'Documento Adicional'});
            this.optionsSelectionTramite = sortObj(this.optionsSelectionTramite, 'asc');
            this.statusOptions = [
                {label: 'Abierta', value: 'Abierta', selected: true, disabled: false},
                {label: 'En Proceso', value: 'En Proceso', selected: false, disabled: false},
                {label: 'Cerrada', value: 'Cerrada', selected: false, disabled: false},
            ];
    
        this.form = fb.group({

            'executive_id': [''],
            'date_received': ['', Validators.compose([Validators.required])],
            'company_id': [''],
            'candidate_id': ['', Validators.compose([Validators.required])],
            'candidate_document': [''],
            'observation_delivery_process': ['', Validators.compose([ Validators.required, Validators.maxLength(500) ])],
            'description_activity': ['', Validators.compose([Validators.required])],
            'status': [''],
            'answer_solution': [''],
            'worked_by_id': [''],
            'date_solution': [''],
            'date_verification_answer': [''],
            'verified_by_id': [''],
            'radication': [''],
            'department_id': [''],
            'venue_id': [''],
            'beneficiaries_registered': [''],
            'tramite': [''],
            'date_delivery': [''],
            'eps_ccf': [''],
            'observations_facilitator': [''],
            'report_user_id': [''],
        });

        this.executive_id = this.form.controls['executive_id'];
        this.date_received = this.form.controls['date_received'];
        this.company_id = this.form.controls['company_id'];
        this.candidate_id = this.form.controls['candidate_id'];
        this.candidate_document = this.form.controls['candidate_document'];
        this.observation_delivery_process = this.form.controls['observation_delivery_process'];
        this.description_activity = this.form.controls['description_activity'];
        this.radication = this.form.controls['radication'];
        this.department_id = this.form.controls['department_id'];
        this.venue_id = this.form.controls['venue_id'];
        this.beneficiaries_registered = this.form.controls['beneficiaries_registered'];
        this.tramite = this.form.controls['tramite'];
        this.date_delivery = this.form.controls['date_delivery'];
        this.eps_ccf = this.form.controls['eps_ccf'];
        this.observations_facilitator = this.form.controls['observations_facilitator'];
        this.report_user_id = this.form.controls['report_user_id'];
        
        // this.date_received.disable();
        // this.status = this.form.controls['status'];
        // this.answer_solution = this.form.controls['answer_solution'];
        // this.worked_by_id = this.form.controls['worked_by_id'];
        // this.date_solution = this.form.controls['date_solution'];
        // this.date_verification_answer = this.form.controls['date_verification_answer'];
        // this.verified_by_id = this.form.controls['verified_by_id'];
    }

    ngOnInit() {
        if (this.edit) {
            this.executive_id.setValue(this.edit.executive_id);
            this.company_id.setValue(this.edit.company_id);
            this.candidate_id.setValue(this.edit.candidate_id);
            this.candidate_document.setValue(this.edit.candidate.identification_number);
            this.observation_delivery_process.setValue(this.edit.observation_delivery_process);
            this.description_activity.setValue(this.edit.description_activity);
            this.date_received.setValue(new Date(this.edit.date_received));    
        } else {
            this.date_received.setValue(new Date());
            // this.activated.setValue(true);
            if (this.gestionSac) {
                if (this.gestionSac.date_time_follow_up) {
                    this.date_received.setValue(new Date(this.gestionSac.date_time_follow_up));
                }
            }
        }
    }

    public cancelWorkerCare () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newWorkerCare(values);
    }

    public newWorkerCare(values) {
        if (!values.status) {
            values.status = 'Abierta';
        }

        let worked_by;
        if (values.worked_by_id) {
            if (values.worked_by_id.id) {
                worked_by = values.worked_by_id.id;
            }
        } 

        let verified_by;
        if (values.verified_by_id) {
            if (values.verified_by_id.id) {
                verified_by = values.verified_by_id.id;
            }
        } 

        let gestion_sac_id;
        if (this.gestionSac) {
            gestion_sac_id = this.gestionSac.id;
        }

        let company_id;
        if (this.gestionSac) {
            if (this.gestionSac.company_id) {
                company_id = this.gestionSac.company_id;
            }
        } else {
            company_id = values.company_id.id
        }

        let employee_id;
        if (this.gestionSac) {
            if (this.gestionSac.employee_id) {
                employee_id = this.gestionSac.employee_id;
            }
        } else {
            employee_id = values.executive_id.id
        }

        let department_id;
        if (values.department_id) {
            department_id = values.department_id.id
        }

        let venue_id;
        if (values.venue_id) {
            venue_id = values.venue_id.id
        }

        let received;
        if (!values.received) {
            received = 0;
        } else {
            received =values.received;
        }

        let transacted;
        if (!values.transacted) {
            transacted = 0;
        } else {
            transacted =values.transacted;
        }
        let report_user_id;
        if(values.report_user_id){
            report_user_id=values.report_user_id.id;
        }

        let param;

        if (values.worked_by_id && values.verified_by_id) {
            param = {
                'gestion_sac_id': gestion_sac_id,
                'executive_id': employee_id,
                'date_received': this.formatDate(values.date_received),
                'company_id': company_id,
                'candidate_id': values.candidate_id.id,
                'observation_delivery_process': values.observation_delivery_process,
                'description_activity': values.description_activity,
            };
        } else if (values.worked_by_id || values.verified_by_id) {
            if (values.worked_by_id) {
                param = {
                    'gestion_sac_id': gestion_sac_id,
                };
            } else if (values.verified_by_id) {
                param = {
                    'gestion_sac_id': gestion_sac_id,
                };
            }
        } else if (this.radication.value) {
            param = {
                'radication': values.radication,
                'gestion_sac_id': gestion_sac_id,
                'executive_id': employee_id,
                'date_received': this.formatDate(values.date_received),
                'company_id': company_id,
                'candidate_id': values.candidate_id.id,
                'observation_delivery_process': values.observation_delivery_process,
                'description_activity': values.description_activity,
                'eps_ccf': values.eps_ccf,
                'tramite': values.description_activity,
                'date_delivery': this.formatDate(values.date_delivery),
                'beneficiaries_registered': values.beneficiaries_registered,
                'observations_facilitator': values.observation_delivery_process,
                'received': received,
                'transacted': transacted,
                'solution': values.solution,
                'department_id': values.department_id,
                'venue_id': values.venue_id,
                'report_user_id': report_user_id,
            }
        } else {
            param = {
                'radication': values.radication,
                'gestion_sac_id': gestion_sac_id,
                'executive_id': employee_id,
                'date_received': this.formatDate(values.date_received),
                'company_id': company_id,
                'candidate_id': values.candidate_id.id,
                'observation_delivery_process': values.observation_delivery_process,
                'description_activity': values.description_activity,
                // 'affiliation_name': values.affiliation_name,
                // 'identification_number': values.identification_number,
                'eps_ccf': values.eps_ccf,
                'tramite': values.description_activity,
                'date_delivery': (values.date_delivery =="")? null:this.formatDate(values.date_delivery),
                'beneficiaries_registered': values.beneficiaries_registered,
                'observations_facilitator': values.observation_delivery_process,
                'received': received,
                'transacted': transacted,
                'solution': values.solution,
            };
        }

        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.workerCareService.updateWorkerCare(this.edit.id, param)
                :
                this.workerCareService.newWorkerCare(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                    this.notificationsService.growlNotify('success', res);
                    // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    public showNewCandidateDialog() {
        this.modViewDialog = true;
    }

    public showResultNewCandidate(msg) {
        this.messages = [];
        this.messages.push(msg);
    }

    public cancelNewCandidate() {
        this.modViewDialog = false;
    }

    public formatDate(date) {
        const d = new Date(date);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        const year = d.getFullYear();
        let hours = '' + d.getHours();
        let minutes = '' + d.getMinutes();
        let seconds = '' + d.getSeconds();

        if (month.length < 2) {
            month = '0' + month;
        }
        if (day.length < 2) {
            day = '0' + day;
        }

        if (hours.length < 2) {
            hours = '0' + hours;
        }

        if (minutes.length < 2) {
            minutes = '0' + minutes;
        }

        if (seconds.length < 2) {
            seconds = '0' + seconds;
        }

        return [year, month, day].join('-') + ' ' + [hours, minutes, seconds].join(':') + '.000';
    }
    
    getFormValidationErrors(form) {
        let value = '';
        Object.keys(form.controls).forEach(key => {
            const controlErrors: ValidationErrors = form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
                });
            }
        });
        return (value);
    }
    // public sortData(data, type) {
    //     let ordered = [];
    //     let dataArr = [].slice.call(data);
    //     let dataSorted = dataArr.sort((a, b) => {
    //         if (type === "asc") {
    //             if (a.label < b.label) return -1
    //             else return 1
    //         } else {
    //             if (a.label > b.label) return -1
    //             else return 1
    //         }
    //     });
    //     dataSorted.forEach(e => ordered.push(e));
    //     return ordered;
    // }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/worker-care/new-worker-care/new-worker-care.component.ts